// src/components/ui/MapModal.tsx
'use client';

export type MapModalProps = {
  open: boolean;
  title: string;
  /** Google Maps 查詢字串，通常傳 address，沒有就傳 branch_name 或 title */
  query: string;
  onClose: () => void;
};

const MapModal = ({ open, title, query, onClose }: MapModalProps) => {
  if (!open) return null;

  const src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&hl=zh-TW&output=embed`;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={`${title || '地圖'} 的地圖`}
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
      onClick={onClose} // 點遮罩關閉
    >
      <div
        className="bg-white rounded-3 shadow"
        style={{ width: 'min(960px, 96vw)', height: 'min(70vh, 680px)' }}
        onClick={(e) => e.stopPropagation()} // 阻止冒泡，不要因為點內容就關閉
      >
        <div className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
          <strong className="me-3 text-truncate">{title || '地圖'}</strong>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={onClose}
            aria-label="關閉地圖"
          >
            關閉
          </button>
        </div>
        <div className="w-100 h-100">
          <iframe
            src={src}
            title="Google Map"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
};

export default MapModal;
